import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ArrowRight, Receipt, Wallet } from "@phosphor-icons/react";
import { formatCurrency } from "@/lib/format";
import type { SupervisorBilling } from "./use-supervisor-billing";

/** Kredit: stanje + link na stranicu kredita. Faktura: dosad nefakturisan iznos. */
export function BillingBalanceCard({ billing }: { billing: SupervisorBilling }) {
  const { t } = useTranslation();
  const isInvoice = billing.billingModel === "invoice";
  const Icon = isInvoice ? Receipt : Wallet;

  return (
    <section className="rounded-xl border border-border/50 bg-card p-5 shadow-sm">
      <div className="flex items-center justify-between gap-3">
        <span className="text-xs font-medium text-muted-foreground">
          {isInvoice ? t("supervisor.billing.uninvoiced") : t("supervisor.billing.creditBalance")}
        </span>
        <div className="flex size-8 items-center justify-center rounded-lg bg-muted/60">
          <Icon className="size-4 text-muted-foreground" />
        </div>
      </div>
      <p
        className="mt-2 text-3xl font-bold tabular-nums text-foreground"
        style={{ fontFamily: "var(--font-heading)" }}
      >
        {formatCurrency(isInvoice ? billing.uninvoicedTotal : billing.creditBalance)}
      </p>
      {isInvoice ? (
        <p className="mt-1 text-xs text-muted-foreground">{t("supervisor.billing.uninvoicedHint")}</p>
      ) : (
        <Link
          to="/dashboard/supervisor/credit"
          className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-primary hover:underline"
        >
          {t("supervisor.billing.creditDetails")} <ArrowRight className="size-3" />
        </Link>
      )}
      {!isInvoice && billing.uninvoicedTotal != null && billing.uninvoicedTotal > 0 && (
        <p className="mt-2 text-xs text-muted-foreground">
          {t("supervisor.billing.uninvoicedFromInvoicePeriod", { amount: formatCurrency(billing.uninvoicedTotal) })}
        </p>
      )}
    </section>
  );
}
